import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.599 5.083v9.787c0 .27.22.49.49.49h9.824c.27 0 .492-.22.492-.49V7.361a.5.5 0 0 0-.145-.345l1.04-1.037c.37.367.575.865.575 1.385v7.506c0 1.08-.881 1.958-1.965 1.958H5.09a1.963 1.963 0 0 1-1.965-1.958V5.083c0-1.08.881-1.958 1.965-1.958h7.536c.522 0 1.023.205 1.39.572l2.288 2.279-1.04 1.037-2.29-2.276-.025-.025v3.062a.734.734 0 0 1-.737.734H6.318a.734.734 0 0 1-.737-.734v-3.18H5.09c-.27 0-.491.22-.491.489m2.455-.49V7.04h4.421V4.593zm.983 7.341c0-.52.207-1.017.575-1.384a1.97 1.97 0 0 1 2.779 0 1.954 1.954 0 0 1 0 2.768 1.97 1.97 0 0 1-2.779 0 1.95 1.95 0 0 1-.575-1.384"
    }, null, -1)
  ]))]))
}
export default { render: render }